import { render, staticRenderFns } from "./payrollSetting.vue?vue&type=template&id=2576aa7c&scoped=true"
import script from "./payrollSetting.vue?vue&type=script&lang=js"
export * from "./payrollSetting.vue?vue&type=script&lang=js"
import style0 from "./payrollSetting.vue?vue&type=style&index=0&id=2576aa7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2576aa7c",
  null
  
)

export default component.exports